import RichTextBlock from './RichTextBlock';

export default RichTextBlock;
